import { render, staticRenderFns } from "./ObservationNewDetails.vue?vue&type=template&id=d883701a&scoped=true&"
import script from "./ObservationNewDetails.vue?vue&type=script&lang=js&"
export * from "./ObservationNewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ObservationNewDetails.vue?vue&type=style&index=0&id=d883701a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d883701a",
  null
  
)

export default component.exports